function subcriptionsclearup() {
  const tabOptions = document.querySelectorAll(".tab-option");
  const contentSections = document.querySelectorAll(".content-section");
  const tabSwitch = document.getElementById("tabSwitch");

  tabOptions.forEach((option) => {
    option.addEventListener("click", function () {
      // Remove active class
      tabOptions.forEach((tab) => tab.classList.remove("active"));
      contentSections.forEach((section) => section.classList.remove("active"));

      // Add active class
      this.classList.add("active");

      // Update switch indicator
      const targetTab = this.dataset.tab;
      tabSwitch.className = `tab-switch ${targetTab}`;

      // Show content
      document.getElementById(targetTab + "-content").classList.add("active");
    });
  });

  const node = document.querySelector(".recharge-subscription-widget");
  const clone = document.querySelector(".content-info.subscribe");
  // main-product-v2 already renders the widget in the tab; re-appending would detach and
  // re-attach it. Elsewhere this behaves as before (including when the widget is missing).
  if (!clone.contains(node)) clone.appendChild(node);

  // fix/pdp-buy-buttons-cls: on main-product-v2 this buy box owns the product form and the
  // buy_buttons block's duplicate isn't rendered, so there's nothing to hide (and the second
  // .product-form__buttons would be the sticky Add to Cart's). main-product still needs this.
  if (document.querySelector('[data-owns-product-form]')) return;

  const buttonsProduct = document.querySelectorAll('.product-form__buttons');

  if (buttonsProduct.length > 1) {
    const second = buttonsProduct[1];
    second.style.setProperty('display', 'none', 'important');
  }

  const buttonsShopPay = document.getElementById('product-form-installment');

  if (buttonsShopPay) {
    buttonsShopPay.style.setProperty('display', 'none', 'important');
  }
}

// Run when data-cart-clear-up="true" is present
function checkClearUpAttribute() {
  const target = document.querySelector('[data-cart-clear-up="true"]');
  if (target) {
    subcriptionsclearup();
  }
}

// Initial check
checkClearUpAttribute();

document.addEventListener("DOMContentLoaded", function() {
subcriptionsclearup();
});
